import React from 'react'
import styles from './main.scss'
import { getCampaignCookieAccepted, setCampaignCookieAccepted } from '../../../globals/storage'
import en from './en'
import de from './de'

class NormalCookie extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sticky: false,
      closed: false,
    }

    const { language } = this.props

    this.text = language === 'en' ? en : de
  }

  componentDidMount() {
    const { loadAnalytics } = this.props
    window.addEventListener('scroll', this.handleScroll)

    this.checkAccepted()
    loadAnalytics()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  checkAccepted() {
    const { campaignId } = this.props

    const hasAccepted = getCampaignCookieAccepted(campaignId)
    if (hasAccepted) {
      this.setState({ closed: true })
    }
  }

  handleScroll = () => {
    const doc = document.documentElement
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

    // handle Cookie positioning
    if (top > 36) {
      this.setState({ sticky: true })
    } else {
      this.setState({ sticky: false })
    }
  }

  handleClose = () => {
    const { campaignId } = this.props

    setCampaignCookieAccepted(campaignId)
    this.setState({ closed: true })
  }

  render() {
    if (this.state.closed) {
      return null
    }

    const wrapperClass = `${styles.cookieWrapper} ${this.state.sticky ? styles.sticky : ''}`

    const Text = this.text

    return (
      <div className={wrapperClass}>
        <div className={styles.left}>
          <Text />
        </div>
        <div className={styles.right} role="button" tabIndex={-1} onClick={this.handleClose}>
          <span className={styles.close}>&times;</span>
        </div>
      </div>
    )
  }
}

export default NormalCookie
